(function () {
  'use strict';

  const MODAL_ID = 'VideoModal';

  function init() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    const video = modal.querySelector('.video-modal__video');
    const closeBtn = modal.querySelector('[data-video-modal-close]');
    if (!video || !closeBtn) return;

    function openModal(triggerEl) {
      const src = triggerEl.dataset.videoModalTrigger;
      if (!src) return;

      const poster = triggerEl.dataset.videoModalPoster;
      const title = triggerEl.dataset.videoModalTitle;

      if (poster) {
        video.setAttribute('poster', poster);
      } else {
        video.removeAttribute('poster');
      }

      if (title) {
        video.setAttribute('aria-label', title);
        const titleEl = modal.querySelector('#VideoModalTitle');
        if (titleEl) titleEl.textContent = title;
      }

      while (video.firstChild) video.removeChild(video.firstChild);
      const source = document.createElement('source');
      source.src = src;
      source.type = inferType(src);
      video.appendChild(source);
      video.load();

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          // Autoplay blocked — user can still hit play via controls.
        });
      }

      modal._lastTrigger = triggerEl;
    }

    function closeModal() {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {
        // ignore
      }
      while (video.firstChild) video.removeChild(video.firstChild);

      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }

      if (modal._lastTrigger && typeof modal._lastTrigger.focus === 'function') {
        modal._lastTrigger.focus();
      }
    }

    function inferType(url) {
      const clean = url.split('?')[0].toLowerCase();
      if (clean.endsWith('.webm')) return 'video/webm';
      if (clean.endsWith('.ogv') || clean.endsWith('.ogg')) return 'video/ogg';
      if (clean.endsWith('.mov')) return 'video/quicktime';
      return 'video/mp4';
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-video-modal-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger);
    });

    closeBtn.addEventListener('click', closeModal);

    // Native <dialog> emits 'close' on Escape too; also handle backdrop click.
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener('close', function () {
      video.pause();
      while (video.firstChild) video.removeChild(video.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
